
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/remote-workforce-report",
      function () {
        return require("private-next-pages/remote-workforce-report.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/remote-workforce-report"])
      });
    }
  